import { gql } from "@apollo/client";

export const CREATE_SEARCH = gql`
  mutation createSearch(
    $location: LocationInput!
    $category: Int!
    $where: WhereInput
    $allow_third_party: Boolean
    $description: String
  ) {
    User {
      createSearch(
        category: $category
        location: $location
        where: $where
        allow_third_party: $allow_third_party
        description: $description
      )
    }
  }
`;

export const DELETE_SEARCH = gql`
  mutation deleteSearch($create_time: Int!) {
    User {
      deleteSearch(create_time: $create_time)
    }
  }
`;

export const INIT_BROKER_COMMISSION = gql`
  mutation initBrokerCommission($data: ClientBrokerCommissionInput!) {
    User {
      initBrokerCommissionPayment(data: $data) {
        client_broker_commission_id
        commission_total
      }
    }
  }
`;

export const ADD_LIKE = gql`
  mutation AddLike($listing_id: Int!) {
    User {
      addLike(listing_id: $listing_id) {
        success
        message
      }
    }
  }
`;

export const REMOVE_LIKE = gql`
  mutation removeLike($listing_id: Int!) {
    User {
      removeLike(listing_id: $listing_id) {
        success
        message
      }
    }
  }
`;

export const SUBMIT_COMPANY_PHOTO = gql`
  mutation submitCompanyPhoto(
    $company_photo: String!
    $is_registered_trademark: Boolean!
    $trademark_certificate: String
  ) {
    User {
      submitCompanyPhotoVerificationRequest(
        company_photo: $company_photo
        is_registered_trademark: $is_registered_trademark
        trademark_certificate: $trademark_certificate
      )
    }
  }
`;

export const INIT_WHATSAPP_PROJECT_BROKER = gql`
  mutation initWhatsappUserProjectBrokerCommunication(
    $project_id: Int!
    $language: Langs!
    $listing_id: Int
  ) {
    User {
      initWhatsappUserProjectBrokerCommunication(
        project_id: $project_id
        language: $language
        listing_id: $listing_id
      ) {
        message
        redirect_url
      }
    }
  }
`;

export const INIT_WHATSAPP_PROJECT_LOCATION = gql`
  mutation initWhatsappUserRequestProjectLocation(
    $project_id: Int!
    $language: Langs!
  ) {
    User {
      initWhatsappUserRequestProjectLocation(
        project_id: $project_id
        language: $language
      ) {
        message
        redirect_url
      }
    }
  }
`;
